import React, { useEffect } from 'react';

import { Typography, Tooltip, Dropdown, MenuButton, Menu, MenuItem, Box } from '@mui/joy';
import Toolbar from '@mui/material/Toolbar';

import calculateReadability from '../../utils/readability_score';
import CircularProgress from '@mui/joy/CircularProgress';

/* Icons */
import IconButton from '@mui/material/IconButton';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

const PostToolbar = ({ content, showEmojiPicker, setShowEmojiPicker, setOpenMediaModal, handleOptimize, postStrengthLoading, handlePostStrength }) => {
    const maxChars = 2990;

    const readabilityResult = calculateReadability(content);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', mt: 0, mb: 1, padding: '0 20px' }}>

            {/* tool tip to include grade score for readability from 0 to 10*/}
            <span style={{ border: '1px solid #c6c3c3', borderRadius: '10px', padding: '0px 10px', fontSize: '12px', fontWeight: 'bold' }}>
                <Tooltip title="Readability Score" arrow sx={{ zIndex: 10000000 }}>
                    <IconButton>
                        <Typography level="body-xs" sx={{ mt: 0.5, mr: 1 }}>Readability Score</Typography>
                        <AutoStoriesIcon />
                    </IconButton>
                </Tooltip>
                <span
                    style={{
                        fontSize: '12px',
                        fontWeight: 'bold',
                    }}>
                    {readabilityResult?.ARI}
                </span>
            </span>

            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginLeft: '1rem', width: '100px' }}>
                <Typography level="body-xs" color={readabilityResult?.numCharacters > maxChars ? 'danger' : 'neutral'} sx={{ textAlign: 'right' }}>
                    {readabilityResult?.numCharacters} / 2990 characters
                </Typography>

            </div>
        </Box>
    );
}

export default PostToolbar;
